import React, { Component } from 'react';
import LogoWhite from './../../logo-proximus-white.png';
import Logo from './../../logo-proximus.png';
import LogoTrans from './../../smallpxslogo.png';

export class Splash extends Component {

    render() {
        return(
            <div className="gradient" style={this.props.getBackground()}>
                <div id="previewHeader">
                    <section>
                        <div>
                            <a className="icon nav-left"></a>
                            { this.props.showTitle()
                                ? <p className="serviceName">{this.props.fieldValues.serviceName}</p>
                                : ''
                            }
                        </div>

                        <h2>{this.props.showMessage('message_12_01')}</h2>

                        <p>{this.props.showMessage('message_12_02')}</p>
                    </section>
                </div>
                <section id="content-section">
                    <div>
                        <h1 className="purple" style={{paddingTop: '10px'}}>{this.props.showMessage('message_12_03')}</h1>
                    </div>
                    <div className="infoPanel">
                        <p style={{textAlign: 'left'}}>{this.props.showMessage('message_12_04')}</p>
                    </div>
                    <div>
                        <form id="pnreg_form">
                            <p className="subtitle"></p>

                            <div id="countrycode_container"><select id="countrycode" style={{display: 'block'}} disabled><option>BE (+32)</option></select></div>

                            <div id="phonenumber_container"><input className="required" id="pnreg_phonenumber" placeholder={this.props.showMessage('message_12_05')} type="text" disabled /></div>

                            <table>
                                <tbody>
                                <tr>
                                    <td style={{paddingRight: '10px'}}><input id="terms-checkbox" type="checkbox" /></td>
                                    <td>
                                        <p>{this.props.showMessage('message_12_06')} <a className="purple">{this.props.showMessage('message_12_07')}</a> {this.props.showMessage('message_12_08')} <a className="purple">{this.props.showMessage('message_12_09')}</a></p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <button id="pnreg_login_btn" disabled>{this.props.showMessage('message_12_10')}</button>
                        </form>
                    </div>
                    <div>
                        <a className="purple" style={{fontWeight: '600'}}>{this.props.showMessage('message_12_11')}</a>
                    </div>
                    <div>
                        <p style={{textAlign: 'right', marginTop: '50px', marginBottom: '15px'}}>{this.props.showMessage('message_12_12')} <img src={LogoTrans} style={{maxWidth: '90px', verticalAlign: 'middle'}} /></p>
                    </div>
                </section>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/preview/Splash.jsx